import React, { useCallback, useContext, useMemo } from "react";
import clsx from "clsx";
import { FaAngleDown } from "react-icons/fa";

import { MenuContext } from "../Menu/MenuContext";
import IconButton from "../../common/IconButton/IconButton";
import Tooltip, { TooltipPlacement } from "../../common/Tooltip/Tooltip";
import { PropsOf } from "../../../lib/types/UtilTypes";

export interface MenuTriggerProps extends PropsOf<"div"> {
	className?: string;
	overflow?: boolean;
	children?: React.ReactNode;
	showArrow?: boolean;
	showOverflowOnHover?: boolean;
}

const MenuTrigger = (props: MenuTriggerProps) => {
	const {
		className,
		overflow,
		showArrow,
		children,
		onClick,
		showOverflowOnHover,
		...otherProps
	} = props;
	const menuContext = useContext(MenuContext);

	const handleClick = useCallback(
		(e: any) => {
			e.currentTarget?.blur();
			menuContext?.toggleVisible();
			if (onClick) {
				onClick(e);
			}
		},
		[menuContext, onClick],
	);

	const tooltipProps = useMemo(
		() => ({
			content: children,
			placement: "bottom" as TooltipPlacement,
			delay: [500, 0] as [number, number],
		}),
		[children],
	);

	const containerEl = showOverflowOnHover ? Tooltip : React.Fragment;
	const containerProps = showOverflowOnHover ? tooltipProps : ({} as any);

	return (
		<div
			className={clsx(
				"MenuTrigger",
				overflow && "--overflow",
				className,
				showOverflowOnHover && "--with-tooltip",
			)}
			onClick={handleClick}
			{...otherProps}
		>
			{React.createElement(containerEl, containerProps, children)}
			{showArrow !== false && (
				<IconButton onClick={handleClick} className={"MenuTrigger__arrow"}>
					<FaAngleDown />
				</IconButton>
			)}
		</div>
	);
};

export default React.memo(MenuTrigger);
